import { NoImage } from "@assets/constant/index.constant";
import { endpoint } from "@services/api.services";
import Tooltip from "@ui/external/components/tooltip";
import { ZoomImage } from "@ui/internal/components/formelement";
import { getFileIcon, showToast } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";
import { Copy, CopyPlus, CopyPlusIcon } from "lucide-react";
import React, { useMemo } from "react";
import { Link, useParams } from "react-router";

const ColumnList = ({ refetch }: { refetch?: () => void }) => {
  const { clearSelection } = useSelectionStore();
  const params = useParams();
  const { handleAction } = useHandleAction({
    refetch,
  });
  const columns = useMemo(
    () => [
      {
        name: "ID",

        cell: (row: any) => {
          return <span className="font-semibold text-gray-700">{row.id}</span>;
        },
        sortable: true,
      },
      {
        name: "Source Name",
        cell: (row: any) => {
          return (
            <div className="flex items-start  gap-2 justify-start w-full h-full">
              <div className="max-w-[110px] w-fit truncate">{row?.name}</div>
            </div>
          );
        },
        sortable: true,
      },
      {
        name: "Actions",
        cell: (row) => (
          <div className="flex items-center gap-3 text-[#1DA077] cursor-pointer">
            {/* {params?.type == "request-form" ? null : (
              <span
                className="cursor-pointer"
                onClick={() => {
                  handleAction({ type: "close" });
                  params.type == "contact-form" ||
                  params.type == "enrollment" ||
                  params.type == "masterclass-enrollment"
                    ? handleAction({ type: "drawer-view", data: row?.id })
                    : handleAction({ type: "modal-view", data: row?.id });
                }}
              >
                View
              </span>
            )} */}
            {/* {params.type == "contact-form" ||
            params.type == "request-form" ? null : (
              <span
                onClick={() =>
                  handleAction({ type: "modal-edit", data: row?.id })
                }
              >
                Edit
              </span>
            )} */}
            <span
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row?.id },
                });
              }}
            >
              Delete
            </span>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );
  return columns;
};

export { ColumnList };
